import { useNavigate } from 'react-router-dom'
import { useGetClubActiveStatus, useGetCopartnerList } from './api/dashboardApi'
import PropTypes from 'prop-types';

const CoPartnerClub = ({ back }) => {
    const { data: getCoPartnerList } = useGetCopartnerList()
    const { data: clubActiveStatus } = useGetClubActiveStatus()
    const activeIds = clubActiveStatus?.count?.map(item => item._id) || [];
    const getColClass = (count) => {
        if (count === 1) return "col-md-12";
        return count % 2 === 0 ? "col-md-6" : "col-md-4";
    };
    const colClass = getColClass(getCoPartnerList?.getClubDetails.length);
    const navigate = useNavigate()
    return (
        <div className="appcard mb-4">
            <div className="cardHeader d-flex justify-content-between flex-wrap">
                <div className='bxTitle mb-3 mb-md-0'>
                    <img src={require('../../assets/images/dashboard/co-partner.svg').default} alt='walletImg.svg' className='co-partner' />
                    <span>Club</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">


                    <div className="row">
                        {getCoPartnerList?.getClubDetails.map((v, i) => {

                            const rankNum = i + 1;
                            const isActive = activeIds.includes(rankNum);
                            return (
                                <div className={colClass} key={v?._id}>
                                    <div className={`rankCardbx ${isActive ? "active green" : " "}`}>
                                        <div className="d-flex justify-content-between align-items-center g-10">
                                            <div className="rankNumTxt">
                                                <div className={`rankNumCir`}>{`0${i + 1}`}</div>
                                                <span
                                                    className="fw-600"
                                                    style={{ color: isActive ? "#FCD535" : "#ffffff" }}
                                                >
                                                    {v?.clubName}
                                                </span>                                            </div>
                                            <button className="btn btnArrowcard1"
                                                onClick={() => navigate(`/slot-details/${v?.clubName}`, { state: { back } })}>
                                                <svg
                                                    width="12"
                                                    height="10"
                                                    viewBox="0 0 12 10"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M8.58881 3.53662L1.28975 9.35339" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M7.95354 9.15769L8.58881 3.53662" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M2.96778 2.90159L8.58885 3.53686" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        )}
                    </div>


                </div>

            </div>
        </div>
    )
}
CoPartnerClub.propTypes = {
    back: PropTypes.any

}
export default CoPartnerClub
